// extracted by mini-css-extract-plugin
export default {"close-button":"interactive-image-preview_close-button__P73kL","image":"interactive-image-preview_image__DZzCO"};